module.exports = __webpack_public_path__ + "img/workbooks_special.80aabedf.png";